import type { ResetPasswordFormMessages } from "@my-langguth/auth-ui";
import { ResetPasswordForm as SharedResetPasswordForm } from "@my-langguth/auth-ui";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import loginImage from "../assets/login.webp";
import { SHOP_AUTH_API_BASE } from "@/lib/shop-auth-api-base";
import { AuthFormFooter } from "@/components/auth-form-footer";

interface ResetPasswordFormProps {
  token: string;
  className?: string;
}

export function ResetPasswordForm({
  token,
  className,
  ...props
}: ResetPasswordFormProps & React.ComponentProps<"div">) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const messages: ResetPasswordFormMessages = {
    errors: {
      passwordMinLength: t("auth.errors.passwordMinLength"),
      passwordMaxLength: t("auth.errors.passwordMaxLength"),
      passwordsDoNotMatch: t("auth.errors.passwordsDoNotMatch"),
      invalidResetToken: t("auth.errors.invalidResetToken"),
      invalidResetTokenDesc: t("auth.errors.invalidResetTokenDesc"),
      resetPasswordFailed: t("auth.errors.resetPasswordFailed"),
      resetPasswordFailedDesc: t("auth.errors.resetPasswordFailedDesc"),
    },
    resetPassword: {
      title: t("auth.resetPassword.title"),
      subtitle: t("auth.resetPassword.subtitle"),
      newPassword: t("auth.resetPassword.newPassword"),
      confirmPassword: t("auth.resetPassword.confirmPassword"),
      submitButton: t("auth.resetPassword.submitButton"),
      backToLogin: t("auth.resetPassword.backToLogin"),
      success: t("auth.resetPassword.success"),
      successDesc: t("auth.resetPassword.successDesc"),
    },
  };

  return (
    <SharedResetPasswordForm
      authBaseUrl={SHOP_AUTH_API_BASE}
      token={token}
      messages={messages}
      heroImageSrc={loginImage}
      onNavigateToLogin={() =>
        navigate({ to: "/login", search: { redirect: undefined } })
      }
      onSuccess={() =>
        navigate({ to: "/login", search: { redirect: undefined } })
      }
      footerSlot={<AuthFormFooter />}
      className={className}
      {...props}
    />
  );
}
